
<template>
  <div class="grid">
    <div class="col-12">
      <Breadcrumb :home="home" :model="items" />
    </div>

    <div class="col-12">
      <div class="p-2 border-2 surface-border surface-card border-round shadow-1">
        <Toolbar class="p-0 m-0">
          <template #end>
            <Button label="Save" icon="pi pi-check p-btn p-btn-sm" class="mr-2 bg-orange-700 border-orange-700 " iconPos="right" :loading="IsSaving" :disabled="IsSaving" @click="SaveAnswers()" />
          </template>
        </Toolbar>
      </div>
    </div>
    <div class="col-12" v-if="!Loading">
      <div class="p-2 border-2 surface-border surface-card border-round shadow-1">
        <Accordion :activeIndex="0" :multiple="false" v-if="Modules.length != 0">
          <AccordionTab v-for="(item, index) in Modules" :key="index" :header="item.key">
            <div class="col-12" v-for="(question, questionIndex) in item.questions" :key="questionIndex">
              <Message class="bg-bluegray-800 text-white" :closable="false">{{question.questionStatement}}</Message>
              <Textarea rows="5" cols="30" v-if="question.questionType == 3" class="w-full" v-model="question.answers.answer" />

              <div v-if="question.questionType == 4">
                <div v-for="option in question.availableQuestionOptions" :key="option.questionOptionId" class="flex align-items-center">
                  <RadioButton :inputId="option.questionOptionId.toString()" :value="option.questionOptionId" v-model="question.answers.questionOptionId" />
                  <label :for="option.questionOptionId" class="ml-2">{{ option.optionDescription }}</label>
                </div>
              </div>
              <Divider />
            </div>
          </AccordionTab>
        </Accordion>
        <Message class="bg-bluegray-800 text-white" :closable="false" v-if="Modules.length == 0">No Content Is Available For This Module</Message>
      </div>
    </div>
  </div>
  <Toast />
</template>

<style>

  .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
    border-color: #FF9800;
    background: #FF5722;
    color: #ffffff;
  }

  .p-message.p-message-info .p-message-icon {
    color: white;
  }

  .p-message.p-message-info {
    background: #e9e9ff;
  }
  .p-message.p-message-info {
    background: #e9e9ff;
    border: solid #9E9E9E;
    border-width: 0 0 0 6px;
    color: #696cff;
  }

  .p-rating .p-rating-item.p-rating-item-active .p-rating-icon {
    color: #f29217;
  }

  .p-selectbutton .p-button.p-highlight:hover {
    background: #9E9E9E;
    border-color: #9E9E9E;
    color: #ffffff;
  }

  .p-selectbutton .p-button.p-highlight:hover {
    background: #FF9800;
    border-color: #FF9800;
    color: #ffffff;
  }

  .p-selectbutton .p-button.p-highlight {
    background: #FF5722;
    border-color: #FF5722;
    color: #ffffff;
  }

  .p-button:focus {
    box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #FF9800, 0 1px 2px 0 black;
  }
</style>

<script>
  import { ref } from "vue";

  export default {

  name: 'ChapterContents',
    emits: ['set-nav'],
    props: ['CourseName'],
    data: () => ({
     Modules: [],
     Loading: true,
     IsSaving: false,
     home: {
    icon: 'pi pi-home',
    to: '/MyDashboard',
     },
      items:[
        { label: 'My Modules', to:'/ELearning' },
        { label: 'Module' },
        { label: 'Chapter' },
      ],
      Layout: ref('grid')
    }),
    created() {

      this.items[1].label = this.$route.query.CourseName
      this.items[1].to = { path: `/Courses`, query: { CourseId: this.$route.query.CourseId, CourseName: this.$route.query.CourseName } }
      this.items[2].label = this.$route.query.ModuleName
      this.$emit("set-nav", this.$route)

      var self = this;

      self.$http.get(`/ELearning/ModuleContents?moduleId=${this.$route.query.ModuleId}&userId=${this.$store.getters.user.id}`, {}).then(function (response) {
        self.Modules = response.data.questionModules
        self.Loading = false;
      })
    },
    methods: {

      SaveAnswers() {

        var self = this;

        self.IsSaving = true;

        var moduleQuestions = this.Modules.map(c => c.questions).flat();

        var answers = new Array();
        var userId = self.$store.getters.user.id;
        console.log(userId);

        for (var i = 0; i < moduleQuestions.length; i++) {

          var answer = moduleQuestions[i].answers;
          answer.userId = userId;
          answers.push(answer);
        }

        self.$http.post(`/ELearning/SaveAnswers`, { Answers: answers }).then(function () {
          self.UpdateAnswers();
          self.$toast.add({ severity: 'success', summary: 'Successfully Saved Answers', sticky: false, life:3000 });
          self.IsSaving = false;
        })
      },

      UpdateAnswers() {
        var self = this;
        this.$http.get(`/ELearning/ModuleContents?moduleId=${this.$route.query.ModuleId}&userId=${this.$store.getters.user.id}`, {}).then(function (response) {
          self.Modules = response.data.questionModules
        })
      }
    }
}</script>